import { DOCUMENT } from '@angular/common';
import { Injectable, afterEveryRender, inject, signal } from '@angular/core';

/** Read the portal's rendered blocking state without changing its loading lifecycle. */
@Injectable({ providedIn: 'root' })
export class AssistantPageAvailability {
  private readonly document = inject(DOCUMENT);
  private readonly blocking = signal(false);
  readonly blocked = this.blocking.asReadonly();
  private readonly sessionWarning = signal(false);
  readonly sessionPaused = this.sessionWarning.asReadonly();

  constructor() {
    // PageLoading is conditionally rendered by the existing page gates. Background
    // refreshes keep their content visible and do not render this blocking overlay.
    // Keep this compatibility adapter inside the assistant, not in portal loaders.
    afterEveryRender(() => {
      this.sessionWarning.set(this.isSessionPaused());
      this.blocking.set(this.isBlocked());
    });
  }

  isSessionPaused(): boolean {
    return this.document.querySelector(
      '[role="alertdialog"][aria-modal="true"][aria-labelledby="session-timeout-title"]',
    ) !== null;
  }

  isBlocked(): boolean {
    return this.isSessionPaused() ||
      this.document.querySelector('app-page-loading [aria-busy="true"]') !== null;
  }
}
